import React, { useEffect, useRef, useState, useCallback } from 'react';
import { useTheme } from '../context/ThemeContext';
import './ToolPage.css';

export default function DetailedPlanner() {
  const iframeRef = useRef(null);
  const [iframeReady, setIframeReady] = useState(false);
  const { theme, fontSize } = useTheme();

  const syncSettings = useCallback(() => {
    iframeRef.current?.contentWindow?.postMessage(
      { type: 'SET_THEME', theme, fontSize },
      '*'
    );
  }, [theme, fontSize]);

  // Forward estimator spending data + initial settings on ready
  useEffect(() => {
    if (!iframeReady) return;
    const iframe = iframeRef.current;
    if (!iframe?.contentWindow) return;
    syncSettings();
    const saved = localStorage.getItem('retirementPlannerSpending');
    if (saved) {
      try {
        const payload = JSON.parse(saved);
        iframe.contentWindow.postMessage({ type: 'LOAD_SPENDING', payload }, '*');
      } catch (e) {}
    }
  }, [iframeReady, syncSettings]);

  // Push theme/fontSize changes any time they change while mounted
  useEffect(() => {
    if (!iframeReady) return;
    syncSettings();
  }, [theme, fontSize, iframeReady, syncSettings]);

  useEffect(() => {
    function handleMessage(event) {
      if (!event.data || typeof event.data !== 'object') return;
      if (event.data.type === 'PLANNER_READY') {
        setIframeReady(true);
        // Echo settings immediately so iframe renders in the right theme
        setTimeout(() => {
          iframeRef.current?.contentWindow?.postMessage(
            { type: 'SET_THEME', theme, fontSize },
            '*'
          );
        }, 50);
      }
    }
    window.addEventListener('message', handleMessage);
    return () => window.removeEventListener('message', handleMessage);
  }, [theme, fontSize]);

  return (
    <div className="tool-page">
      <div className="tool-toolbar">
        <div className="tool-toolbar-left">
          <h2 className="tool-title">Detailed Retirement Planner</h2>
        </div>
      </div>

      <div className="tool-frame-wrapper">
        <iframe
          ref={iframeRef}
          src="/tools/detailedPlanner.html"
          title="Detailed Canadian Retirement Planner"
          className="tool-iframe"
          sandbox="allow-scripts allow-same-origin allow-forms allow-downloads allow-modals"
        />
      </div>
    </div>
  );
}